<template>
  <vm-player class="vime-player" theme="light">
    <vm-audio>
      <source :data-src="src" type="video/mp4" />
    </vm-audio>
    <vm-ui>
      <vm-controls>
        <vm-playback-control />
        <span class="text-sm">语音播报</span>
        <vm-current-time />
        <vm-scrubber-control />
        <vm-volume-control />
      </vm-controls>
    </vm-ui>
  </vm-player>
</template>
<script>
import {
  Player as VmPlayer,
  Audio as VmAudio,
  Ui as VmUi,
  Controls as VmControls,
  Control as VmControl,
  ControlSpacer as VmControlSpacer,
  MuteControl as VmMuteControl,
  ScrubberControl as VmScrubberControl,
  CurrentTime as VmCurrentTime,
  VolumeControl as VmVolumeControl,
  PlaybackControl as VmPlaybackControl
} from "@vime/vue";

import { useToggle } from "@vueuse/core";

export default {
  components: {
    VmPlayer,
    VmAudio,
    VmUi,
    VmControls,
    VmControl,
    VmControlSpacer,
    VmMuteControl,
    VmScrubberControl,
    VmCurrentTime,
    VmVolumeControl,
    VmPlaybackControl
  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  setup() {
    const [paused, onTogglePaused, ...rest] = useToggle(false);
    return {
      paused,
      onTogglePaused,
    };
  },
  // methods: {
  //   onTogglePaused() {
  //     this.toggle();
  //   },
  // },
};
</script>
<style lang="scss">

@import "@vime/core/themes/default.css";
@import "@vime/core/themes/light.css";
.vime-player {
  --vm-player-theme: #{$color-primary};
  --vm-controls-bg: #edf1f4 !important;
  --vm-control-icon-size: 24px;
  --vm-player-box-shadow: none !important;
  --vm-controls-padding: 8px 12px !important;
  --vm-control-padding: 0;
  --vm-slider-track-height: 5px;
  --vm-scrubber-buffered-bg: #9ba0ae !important;
  --vm-slider-value-color: #ccd1e2 !important;
}

</style>